import React from 'react'
import { ColumnRank, ColumnStartOrder, ColumnBib, ColumnName, ColumnNoc, ColumnResult, ColumnRecords, ColumnQualification, ColumnExpander } from "components/common/TableColumns"
import { CellTieRule } from './ColumnsFinish';
import { ColumnWarnings } from "components/sports/ath/race_road/results/ColumnsLive"


export function TableColumns() {

    return (
        [
            ColumnRank({}),
            ColumnNoc({}),
            ColumnName({}), 
            ColumnResult({}),
            {
                accessor: 'extendedResults',
                id: 'TieRules',
                Cell: (props) => (
                    props.cell.row.original.extendedResults
                        ? <CellTieRule extendedResults={props.cell.row.original.extendedResults}></CellTieRule>
                        : ''
                )
            },
            ColumnRecords({}),
            ColumnWarnings({}),
            ColumnExpander({ type: 'extendedResults' })
        ]
    )
}


export default TableColumns
